import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { PROJECT_IMAGES } from "@/lib/brand";
import { TID } from "@/constants/testIds/dv";

export const Projects = () => {
  const { t } = useLanguage();

  return (
    <section
      id="projects"
      data-testid={TID.projectsSection}
      className="bg-background py-24 md:py-32"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#E63946]" />
              <span className="label-eyebrow">{t("projects.eyebrow")}</span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight">
              {t("projects.title")}
            </h2>
          </div>
          <p className="md:max-w-md text-muted-foreground text-base leading-relaxed">
            {t("projects.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {PROJECT_IMAGES.map((p, i) => (
            <div
              key={p.src}
              className={`group relative overflow-hidden rounded-sm border border-border bg-black ${
                i === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <img
                src={p.src}
                alt={p.label}
                data-testid={TID.projectImage(i)}
                className={`w-full object-cover transition-all duration-700 group-hover:scale-105 ${
                  i === 0 ? "h-[420px] md:h-[560px]" : "h-[260px] md:h-[272px]"
                }`}
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black to-transparent p-5">
                <div className="font-display uppercase text-lg text-white tracking-tight">
                  {p.label}
                </div>
                <div className="text-[11px] uppercase tracking-[0.25em] text-[#E63946] mt-1">
                  Insulation
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
